module.exports = __webpack_public_path__ + "static/media/Ghavamin.6d30bb85.svg";